// src/pages/PrivacyPolicy.tsx
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
  Divider
} from '@mui/material';

const PrivacyPolicy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container sx={{ py: 5 }}>
      <Paper elevation={3} sx={{ p: isMobile ? 3 : 5, borderRadius: 4 }}>
        <Typography
          variant={isMobile ? 'h5' : 'h4'}
          gutterBottom
          fontWeight="bold"
          color="primary"
        >
          개인정보처리방침
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ lineHeight: 1.8 }}>
          <Typography gutterBottom>
            다원트레이드(이하 "회사")는 고객의 개인정보를 중요시하며,
            「개인정보 보호법」 등 관련 법령을 준수합니다. 본
            개인정보처리방침은 회사가 제공하는 중고 디바이스 매입
            서비스(이하 "서비스") 이용과 관련하여 수집되는 개인정보의 처리
            방침을 안내합니다.
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            1. 수집하는 개인정보 항목 및 수집방법
          </Typography>
          <Typography>
            - 수집 항목: 이름, 연락처(휴대폰 번호), <strong>CI(연계정보)</strong>,
            기기 정보, 주소 등 신청서 작성 시 입력하는 정보 <br />
            - 수집 방법: 온라인 신청서 작성 및 본인인증을 통해 자동 수집
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            2. 개인정보 수집 및 이용 목적
          </Typography>
          <Typography>
            - 중고 디바이스 매입 신청 접수 및 진행 <br />
            - 본인 확인 및 고객 문의 응대 <br />
            - 서비스 이용 통계 및 분석
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            3. 개인정보의 보유 및 이용 기간
          </Typography>
          <Typography>
            ① 이용자의 개인정보는 다음과 같이 개인정보의 수집 목적 또는
            제공받은 목적이 달성되면 지체 없이 파기됩니다. <br />
            - 회원가입 정보: 회원 탈퇴 또는 자격 상실 시 <br />
            - 대금 지급 정보: 대금 완제일 또는 채권 소멸시효 만료 시 <br />
            - 배송 정보: 상품 또는 서비스 제공 완료 시 <br />
            - 설문조사 및 이벤트: 해당 목적 종료 시 <br />
            <br />
            ② 단, 관련 법령에 따라 일정 기간 보관이 필요한 경우에는 다음과 같이 보관됩니다. <br />
            - 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률) <br />
            - 대금결제 및 재화 등의 공급에 관한 기록: 5년 <br />
            - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 <br />
            - 웹사이트 방문기록: 3개월 (통신비밀보호법) <br />
            <br />
            ③ 이용자가 동의를 통해 제공된 거래정보 등의 열람을 요청하는 경우, 회사는 지체 없이 해당 정보를 열람하거나 확인할 수 있도록 조치합니다.
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            4. 개인정보의 제3자 제공
          </Typography>
          <Typography>
            회사는 이용자의 사전 동의 없이는 개인정보를 외부에 제공하지 않으며, 다음의 경우 예외로 합니다. <br />
            - 법령에 의거하거나 수사기관의 요청에 따라 제공이 필요한 경우
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            5. 개인정보의 처리 위탁
          </Typography>
          <Typography>
            회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리를 위탁하고 있습니다. <br />
            - 위탁사: 비즈톡 (카카오 알림톡 발송 목적) <br />
            - 위탁 내용: 신청 상태 안내 및 고객 알림 전송
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            6. 정보주체의 권리와 행사 방법
          </Typography>
          <Typography>
            - 정보주체는 언제든지 본인의 개인정보를 조회, 수정, 삭제 요청할 수 있습니다. <br />
            - 요청은 이메일(dawontrade@dwt.kr) 또는 고객센터를 통해 가능합니다.
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            7. 개인정보의 파기절차 및 방법
          </Typography>
          <Typography>
            - 개인정보는 수집 목적 달성 후 즉시 파기됩니다. <br />
            - 전자적 파일 형태는 복구 불가능한 방식으로 삭제하며, 출력물은 분쇄 또는 소각합니다.
          </Typography>

          <Typography variant="h6" mt={4} gutterBottom>
            8. 개인정보 보호책임자
          </Typography>
          <Typography>
            - 책임자: 서광필 <br />
            - 이메일: dawontrade@dwt.kr
          </Typography>

          <Typography variant="body2" color="text.secondary" mt={4}>
            ※ 본 방침은 2025년 5월 6일부터 적용됩니다.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
